import _ from "lodash";
import queryString from "query-string";
import { IChannel } from "@hellocontento/contento-common";

import {
  getTime,
  setDate,
  isToday,
  getDayOfWeek,
  getRandomMinutes
} from "utils/date";
import { fetchBestTimes } from "components/schedule/services/taskServices";

interface ResolveBestTimeParams {
  accountId: string;
  accountChannels: IChannel[];
  selectedChannelIds: string[];
  date: Date;
}

interface BestTime {
  hour: number;
}

export const resolveBestTime = async ({
  accountId,
  accountChannels,
  selectedChannelIds,
  date
}: ResolveBestTimeParams): Promise<Date> => {
  const services = _.uniq(
    accountChannels
      .filter(channel => channel.active && selectedChannelIds.includes(channel.id))
      .map(channel => channel.service)
  );
  const query = queryString.stringify({
    service: services,
    dayOfTheWeek: getDayOfWeek(date).toUpperCase()
  });
  const bestTimes: BestTime[] = await fetchBestTimes(accountId, query);

  const hour = isToday(date)
    ? bestTimes.find(bestTime => bestTime.hour > getTime(date).hours)?.hour
    : bestTimes[0]?.hour;
  if (hour === undefined) {
    throw new Error("No best posting time left on that day");
  }

  return setDate(date, { hours: hour, minutes: getRandomMinutes() });
};
